import { useTranslation } from 'react-i18next';
import Btn from './Btn/Btn';
import { usePWAInstall } from '../hooks/usePWAInstall';

/**
 * Универсальная кнопка установки приложения.
 *
 * Прячется, если установка недоступна или уже выполнена.
 * Поддерживает переопределение className, чтобы вписаться в разные места UI.
 */
export default function InstallAppButton({ className }) {
    const { t } = useTranslation('basic');
    const { canInstall, install } = usePWAInstall();

    if (!canInstall) return null;

    return (
        <Btn
            text={t('install_app_button')}
            width='100%'
            className={className}
            onClick={install}
        />
    );
}

